<template lang="html">
  <section class="list-entries ultimas-noticias container">
    <template v-if="success == '0'">
     <div class="all-entries">
      <blog-el
        v-if="noticia.title != titlenoticia"
        v-for="(noticia, key) in noticiasFiltradas"
        :key="key"
        :imageUrl="noticia.header_img.url"
        :title="noticia.title"
        :description="noticia.header"
        :slug="noticia.slug"
        :date="noticia.updated_at"
      >
      </blog-el>
    </div>
    </template>
    <template v-if="success == '1'">
     <div class="all-entries">
      <blog-el
        v-if="noticia.title != titlenoticia"
        v-for="(noticia, key) in casosExito"
        :key="key"
        :imageUrl="noticia.header_img.url"
        :title="noticia.title"
        :description="noticia.header"
        :slug="noticia.slug"
        :date="noticia.updated_at"
      >
      </blog-el>
    </div>
    </template>
    
  </section>
</template>

<script lang="js">
import router from '@/router';
import blogEl from "@/components/parts/blog-el.vue";
import moment from 'moment'
import { mapGetters, mapActions } from "vuex";
export default  {
  name: 'blog',
  props: ["titlenoticia", "success"],
  mounted() {
    this.setData();

  },
  data() {
    return {
      noticia : [],
      textSearch: "",
      data:[],
      total: null,
      actualPage: 1,
      tituloNoticiaActual : this.titlenoticia
      //noticiasLength : document.querySelectorAll('.blog-el').length
    }
  },
  methods: {
     currentDateTime(date) {
      return moment(date).locale('es').format('LL')
    },

    ...mapActions(["requestNoticia"]),
    setData() {
      let data = {
        length: 6,
        page: this.actualPage,
         order: [
          {
            name: "updated_at",
            direction: "desc",
          },

        ]

      };

      this.loading = true;

      this.requestNoticia(data).then((r) => {
        this.noticia = r.data;
        this.loading = false;
        this.total = r.recordsFiltered
      });
    }
  },
   computed: {
    ...mapGetters({
      server: "getServer",
    }),
    casosExito: function() {
      let noticiasCasoExito = this.noticia.filter((noticia) => {
        return noticia.successes == "1";
      });
      return noticiasCasoExito;
    },
    noticiasFiltradas: function() {
      let noticiaNormal = this.noticia.filter((noticia) => {
        return noticia.successes == "0";
      });
      return noticiaNormal;
    }
  },
  components: {
     "blog-el": blogEl
  },
  watch: {
    $route() {
       this.setData()
       //this.noticiasLength = document.querySelectorAll('.blog-el').length
    },
    

  },
}
</script>
<style>
.list-entries.ultimas-noticias .blog-el:nth-child(4) {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ultimas-noticias-blog.vue